import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [config, setConfig] = useState(null);

  const loadConfig = async () => {
    try {
      const { data } = await api.get("/config");
      setConfig(data);
    } catch (e) {}
  };

  useEffect(() => {
    (async () => {
      const t = localStorage.getItem("ohc_token");
      if (!t) { setUser(false); return; }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        loadConfig();
      } catch (e) {
        localStorage.removeItem("ohc_token");
        setUser(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ohc_token", data.token);
    setUser(data.user);
    loadConfig();
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("ohc_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, config, refreshConfig: loadConfig, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
